import { del, get, post, put } from '../../api-config';
import { gdpService, getLocale } from './_service';

// Measures
export const getMeasuresTypes = () => get(gdpService, '/measures/types', null, { locale: getLocale() });
export const getMeasuresUnits = () => get(gdpService, '/measures/units', null, null);
export const getMeasuresGenericTypes = () =>
  get(gdpService, '/measures/genericTypes', null, { locale: getLocale() });
export const getMeasuresStatus = () => get(gdpService, '/measures/status', null, null);

// Demographics
export const getRacesTypes = () => get(gdpService, '/races', null, { locale: getLocale() });
export const getSexesTypes = () => get(gdpService, '/sexes', null, { locale: getLocale() });

// Resolutions / pathologies / relationships
export const getResolutions = () => get(gdpService, '/resolutions', null, { locale: getLocale() });
export const postResolution = (data: any) => post(gdpService, '/resolutions', data, null);
export const putResolution = (data: any) => put(gdpService, '/resolutions', data, null);
export const getPathologiesTypes = () => get(gdpService, '/health-data/pathologies', null, null);
export const getRelationshipsTypes = () => get(gdpService, '/relationships', null, { locale: getLocale() });

// Personal data dropdowns
export const getPatientPersonalDataTypesMaritalStatus = (path: any) =>
  get(gdpService, `/personal-data/${path}`, null, { locale: getLocale() });
export const getPatientPersonalDataTypesLanguage = (path: any) =>
  get(gdpService, `/personal-data/${path}`, null, { locale: getLocale() });
export const getPatientPersonalDataTypesEducation = (path: any) =>
  get(gdpService, `/personal-data/${path}`, null, { locale: getLocale() });
export const getPatientPersonalDataTypesEthnicity = (path: any) =>
  get(gdpService, `/personal-data/${path}`, null, { locale: getLocale() });
export const getPatientPersonalDataTypesWeightBaseline = (path: any) =>
  get(gdpService, `/personal-data/${path}`, null, null);

// Health insurance
export const getPatientHealthInsuranceTypehealthCenter = () =>
  get(gdpService, `/health-service/health-center`, null, null);

// Service types
export const getServiceType = () => get(gdpService, '/patients/service-types', null, { locale: getLocale() });
export const getServiceReasonType = () => get(gdpService, `/service-state-reason`, null, { locale: getLocale() });
export const postServiceStateReason = (data: any) => post(gdpService, `/service-state-reason`, data, null);
export const putServiceStateReason = (data: any) => put(gdpService, `/service-state-reason/${data.id}`, data, null);
export const deleteServiceStateReason = (id: string) => del(gdpService, `/service-state-reason/${id}`);
export const restoreServiceStateReason = (id: string) => put(gdpService, `/service-state-reason/${id}/restore`, {}, null);

// Settings catalogs
export const getSettingsLanguages = () => get(gdpService, '/settings-languages', null, null);
export const getSettingsMeasurementUnits = () => get(gdpService, '/settings-measurement-units', null, null);
export const getSettingsDateFormat = () => get(gdpService, '/settings-date-format', null, null);
